import React from 'react';

export default class Base extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.bound = {};
  }

  bind(functionName) {
    if (typeof this[functionName] === 'function') {
      this.bound[functionName] = this[functionName].bind(this);
    } else {
      console.error(`Component.bind: ${functionName} is an unknown function`);
    }
  }

  propsDidChange(newProps) {
    let didChange = false;
    Object.keys(this.props).forEach(key => {
      if (this.props[key] !== newProps[key]) {
        didChange = true;
      }
    });

    return didChange;
  }

  css(options) {
    var base = this.constructor.name
      .replace(/([A-Z])/g, function($1) {
        return '-' + $1.toLowerCase();
      })
      .substr(1);
    var classes = base;

    if (options) {
      if ('base' in options) {
        classes = base = options.base;
        delete options['base'];
      }

      for (var option in options) {
        if (option !== 'compose' && options[option]) {
          classes += ` ${base}-${option}`;
        }
      }

      if (options.compose) {
        for (var c = 0; c < options.compose.length; c++) {
          classes += ` ${options.compose[c]}`;
        }
      }
    }

    if (this.props && this.props.addClassName) {
      classes += ` ${this.props.addClassName}`;
    }

    return classes;
  }

  addTranslationStyle(...args) {
    return this.getTranslationStyle(...args);
  }

  getTranslationStyle(x, y, styles) {
    if (typeof x === 'object') {
      y = x.y;
      styles = x.styles;
      x = x.x;
    }
    if (typeof y === 'object') {
      styles = y;
      y = 0;
    }
    x = x || 0;
    y = y || 0;
    styles = styles || {};

    let translate = `translate(${x}px, ${y}px)`;
    styles.transform = translate;
    styles.msTransform = translate;
    styles.WebkitTransform = translate;

    return styles;
  }

  get isMobile() {
    if (this.props.wip && this.props.wip.isMobile !== undefined) {
      return this.props.wip.isMobile;
    }

    if (typeof window !== 'undefined') {
      var ua = (
        navigator.userAgent ||
        navigator.vendor ||
        window.opera
      ).toLowerCase();
      return (
        /android|(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          ua
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          ua.substr(0, 4)
        )
      );
    } else {
      return true;
    }
  }

  getModuleFromCuratedContent(result, id) {
    if (result && result.modules && result.modules.length) {
      let modules = result.modules;
      for (let m = 0; m < modules.length; m++) {
        let module = modules[m];
        if (module.id === (id || this.props.curatedModule)) {
          return module;
        }
      }
    }
    return [];
  }

  pad(t) {
    return t < 10 ? '0' + t : t;
  }

  formatDuration(s) {
    var seconds = Math.floor(s % 60);
    var minutes = Math.floor((s / 60) % 60);
    var hours = Math.floor(s / 3600);
    var str = this.pad(minutes) + ':' + this.pad(seconds);

    if (hours > 0) {
      str = hours + ':' + str;
    }
    return str;
  }

  wrapListInTag(list, tag) {
    tag = tag || 'li';

    if (!list instanceof Array) {
      console.log('wrapListInTag error: not list');
      return false;
    }

    let items = [];
    for (let i = 0; i < list.length; i++) {
      items.push(React.createElement(tag, { key: i }, list[i]));
    }

    return items;
  }

  // Send track event to google analytics
  track(category, action, label) {
    if (typeof ga === 'function') {
      var data = {
        eventCategory: category,
      };

      if (action) data.eventAction = action;
      if (label) data.eventLabel = label;

      ga('send', 'event', data);
    }
  }

  cut(str, length) {
    if (str.length < length) {
      return str;
    } else {
      return str.substr(0, length) + '...';
    }
  }

  getImageApiUrl(model, width, options) {
    let url = model.imageApiUrl;
    let density = 1.0;
    if (typeof window !== 'undefined' && window.devicePixelRatio) {
      density = window.devicePixelRatio;
    } else if (this.isMobile) {
      density = 2.0;
    }
    width *= density;

    // Snap to nearest
    let snap = width < 50 ? 10 : 50;
    let newWidth = Math.round(snap * Math.ceil(width / snap));

    url += `?w=${newWidth}&h=${newWidth}`;

    if (
      options.blur ||
      options.color !== undefined ||
      options.opacity !== undefined
    ) {
      url += '&filters=true';

      if (options.blur) {
        url += `&blur=${typeof options.blur === 'Number' ? options.blur : 50}`;
      }
      if (options.color !== undefined) {
        url += `&color=${options.color}`;
      }
      if (options.opacity !== undefined) {
        url += `&opacity=${options.opacity}`;
      }
    }

    return url;
  }
}



// WEBPACK FOOTER //
// ./client/components/base.es6